module.exports = __webpack_public_path__ + "static/media/slide_2x2.ebb33086.png";